import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-brown-900 text-white mt-16">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center">
          <p className="text-sm opacity-80">
            © 2025 Uganda Insider. All rights reserved.
          </p>
          <p className="text-xs mt-2 opacity-60">
            Email: <a href="mailto:info@coloursandsquares.co.uk" className="hover:text-gold-500">info@coloursandsquares.co.uk</a>
          </p>
          <p className="text-xs mt-2">
            <a href="#" className="hover:text-gold-500 underline">Unsubscribe</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;